import React from 'react';
import classnames from 'classnames';
import s from './FeedContent.scss';
var FeedContent = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement("div", { className: classnames(s['root'], className) }, children);
};
FeedContent.displayName = 'FeedContent';
export default FeedContent;
//# sourceMappingURL=FeedContent.js.map